export default "__VITE_ASSET__CgqXtAD8__"